module.exports = __webpack_public_path__ + "img/chopping-board-drawer.63e73b34.jpg";